import { Reveal } from "./motion";

// Numbered manifesto chapter. `tone` picks the section palette.
export const Chapter = ({ id, number, kicker, heading, children, tone = "oat", testId }) => {
  const tones = {
    oat: "bg-oat text-ink",
    mushroom: "bg-mushroom text-ink",
    "mushroom-light": "bg-mushroom-light text-ink",
  };
  return (
    <section id={id} data-testid={testId} className={`${tones[tone]} px-5 sm:px-8 lg:px-12 py-24 sm:py-32`}>
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <div className="flex items-baseline gap-4">
              <span className="font-display font-black text-6xl sm:text-7xl leading-none text-ink/25">
                {number}
              </span>
              <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.24em] text-ink/60 pt-2">
                {kicker}
              </span>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <h2 className="font-display font-black lowercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
              {heading}
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-7 space-y-5 text-lg sm:text-2xl font-medium leading-[1.2] text-ink/85 max-w-2xl">
              {children}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
